import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@knockrentals/knock-shared-web';
import ConfirmationDialog from '../../../Pages/Features/common/ConfirmationDialog';
import { PAGE_NAVIGATION_PROMPT_CONFIG } from '../../../constants';

const CustomRouterPrompt = (view, callback) => {
  const container = document.createElement('div');
  container.setAttribute('custom-router-prompt', '');

  document.body.appendChild(container);

  const handleCallback = (isLeavingPage) => {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
    callback(isLeavingPage);
  };

  const handleOnclose = (_e, reason) => {
    if (reason !== 'backdropClick') {
      handleCallback(false);
    }
  };

  const handleConfirmation = () => {
    handleCallback(false);
  };

  const handleSecondaryButtonOnClick = () => {
    handleCallback(true);
  };

  const config = PAGE_NAVIGATION_PROMPT_CONFIG[view];

  ReactDOM.render(
    <ThemeProvider>
      <ConfirmationDialog
        closeDialog={handleOnclose}
        handleConfirmation={handleConfirmation}
        isOpen
        message={config.MESSAGE}
        primaryButtonText={config.PRIMARY_BUTTON_TEXT}
        secondaryButtonAction={handleSecondaryButtonOnClick}
        secondaryButtonText={config.SECONDARY_BUTTON_TEXT}
        title={config.TITLE}
      />
    </ThemeProvider>,
    container
  );
};

export default CustomRouterPrompt;
